import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { InlineSearchCommands } from '../enums';

export class InlineSearchSendEvent implements IEvent {
	public static readonly EventType = InlineSearchCommands.INLINE_SEARCH_SEND_EVENT;
	public readonly timestamp = new Date();
	public readonly eventType = InlineSearchSendEvent.EventType;

	public static is(event: IEvent): event is InlineSearchSendEvent {
		return event.eventType === InlineSearchSendEvent.EventType as string;
	}
}